import { Collapse, Stack, Divider } from "@mantine/core";
import TagsInput from "./components/TagsInput";
import DateRange from "./components/DateRange";
import { OrderStatus } from "../../../../generated/graphql";
import MultiSelect from "./components/MultiSelect";
import { useOrderListFilter } from "../../contexts/OrderListFilterContext";
import Boolean from "./components/Boolean";
import { isUserStaff, User } from "@jasper/shared";
import { useMemo } from "react";
import { PROVIDER_ALLOWED_STATUSES } from "../../../../constants/orders";

interface AdvancedFilterPanelProps {
  user: User;
  isAdvancedFilterPanelOpened: boolean;
}

const AdvancedFilterPanel = ({
  user,
  isAdvancedFilterPanelOpened,
}: AdvancedFilterPanelProps) => {
  const {
    statuses,
    setStatuses,
    references,
    setReferences,
    clinicCodes,
    setClinicCodes,
    doctors,
    setDoctors,
    providers,
    setProviders,
    createdAt,
    setCreatedAt,
    deliveryDate,
    setDeliveryDate,
    lastShippingDate,
    setLastShippingDate,
    isArchived,
    setIsArchived,
  } = useOrderListFilter();

  const allowedStatusFilters = useMemo(() => {
    if (isUserStaff(user)) {
      return Object.values(OrderStatus);
    }

    return PROVIDER_ALLOWED_STATUSES;
  }, [user]);

  return (
    <Collapse expanded={isAdvancedFilterPanelOpened} w="100%">
      <Stack gap="md" align="flex-start" w="100%">
        <MultiSelect
          filterName="Statuses"
          onChange={setStatuses}
          values={statuses}
          data={allowedStatusFilters}
        />
        <TagsInput
          filterName="References"
          onChange={setReferences}
          values={references}
        />
        <Divider w="100%" />
        <TagsInput
          filterName="Clinic Codes"
          onChange={setClinicCodes}
          values={clinicCodes}
        />
        <Divider w="100%" />
        <TagsInput
          filterName="Doctors"
          onChange={setDoctors}
          values={doctors}
        />
        <Divider w="100%" />
        <TagsInput
          filterName="Providers"
          onChange={setProviders}
          values={providers}
        />
        <Divider w="100%" />
        <DateRange
          filterName="Created at"
          onDateChange={setCreatedAt}
          dateFilter={createdAt}
        />
        <Divider w="100%" />
        <DateRange
          filterName="Delivery date"
          onDateChange={setDeliveryDate}
          dateFilter={deliveryDate}
        />
        <Divider w="100%" />
        <DateRange
          filterName="Last shipping date"
          onDateChange={setLastShippingDate}
          dateFilter={lastShippingDate}
        />
        <Divider w="100%" />
        <Boolean
          filterName="Is archived"
          value={isArchived}
          onChange={setIsArchived}
        />
      </Stack>
    </Collapse>
  );
};

export default AdvancedFilterPanel;
